/**
 * @file: cube数据库初始化
 * @author: xiaolong.huang@dmall.com
 */

import __updateShelfsPosition__ from './updateShelfsPosition';
import { __getShelvesMap__, __clear__, __set__ } from './db';

export function init(stageCube: CubeNode): void {
    __clear__();

    let shelvesMap: CubeMap = __getShelvesMap__();

    stageCube.walk((cube) => {
        __set__(cube.id, cube);
    });
    __updateShelfsPosition__();
    stageCube.ShelvesMap = shelvesMap;
}
